export default {"src":"/pro/_next/static/media/dot.f53d078c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};